<template>
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-account-cog-outline</v-icon>
        <h1 class="page-title">User Profile</h1>
      </v-layout>
    </div>
    <v-form v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="12" lg="3" md="6" sm="12"
            ><v-text-field
              label="Email"
              required
              v-model="user.email"
              :rules="[v => !!v || 'Email is required']"
            ></v-text-field
          ></v-col>
          <v-col cols="12" lg="3" md="6" sm="12"
            ><v-text-field
              label="Username"
              required
              v-model="user.userName"
              :rules="[v => !!v || 'Username is required']"
            ></v-text-field
          ></v-col>
          <v-col cols="12" lg="3" md="6" sm="12"
            ><v-text-field
              label="Phone"
              v-model="user.mobileAlias"
            ></v-text-field
          ></v-col>
          <v-col cols="12" lg="3" md="6" sm="12"
            ><v-autocomplete
              item-text="name"
              item-value="memberId"
              label="Member"
              v-model="user.memberId"
              :items="members"
            >
            </v-autocomplete
          ></v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            :disabled="!valid"
            class="mr-4"
            @click="onSave"
            >Save</v-btn
          >
        </v-row>
      </v-container>
    </v-form>
    <div>
      <statusalert ref="alert"></statusalert>
    </div>
  </div>
</template>

<script>
import store from '@/store/index.js'
import UsersService from '../../services/api/UsersService'
import MembersService from '../../services/api/MembersService.js'
import statusalert from '../../components/StatusAlert'
import loggedInMixin from '../../mixins/loggedInMixin'

export default {
  name: 'accountprofile',
  mixins: [loggedInMixin],
  data() {
    return {
      members: [],
      user: {
        userId: 0,
        userName: '',
        email: '',
        mobileAlias: '',
        memberId: ''
      },
      result: null,
      valid: false
    }
  },
  components: {
    statusalert
  },
  created() {
    this.fetch()
    this.fetchMembers()
  },

  methods: {
    fetch() {
      store.commit('isLoading')
      this.user.userId = this.$store.getters.getUserId
      UsersService.getUser(this.user.userId)
        .then(user => {
          this.user = user
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },

    fetchMembers() {
      store.commit('isLoading')
      this.members = []
      MembersService.get()
        .then(members => {
          for (var i = 0; i < members.length; i++) {
            const member = members[i]
            const m = {
              name: member.lastname + ', ' + member.firstname,
              memberId: member.memberId
            }
            this.members.push(m)
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },
    onSave() {
      store.commit('isLoading')
      UsersService.update(this.user)
        .then(result => {
          this.result = {
            isValid: true,
            statusCode: result.status,
            errors: ['Profile has been updated']
          }
          store.commit('setMemberId', this.user.memberId)
        })
        .catch(error => {
          console.log(error)
          this.result = {
            isValid: false,
            statusCode: 404,
            errors: ['Failed to update board member']
          }
        })
        .finally(() => {
          store.commit('notLoading')
          this.displayAlert()
        })
    },

    displayAlert() {
      this.$refs.alert.displayResult(this.result)
    }
  },

  store: store
}
</script>

<style lang="scss" scoped></style>
